import keyBy from 'lodash/keyBy'

// These actions all have a `products` field on their payload
const productActions = ['RECEIVE_PRODUCTS', 'RECEIVE_COLLECTION']

export default function products(state = {}, action) {
  if (productActions.includes(action.type)) {
    return {
      ...state,
      ...keyBy(action.payload.products, 'permalink'),
    }
  }

  switch (action.type) {
    case 'RECEIVE_SIMILAR_PRODUCTS':
      return {
        ...state,
        [action.payload.permalink]: {
          ...state[action.payload.permalink],
          similar_products: action.payload.similarProducts,
        },
      }

    case 'RECEIVE_RECENTLY_VIEWED_PRODUCTS':
      return {
        ...state,
        recentlyViewed: action.payload.recentlyViewed,
      }

    case 'RECEIVE_STYLED_PRODUCTS':
      return {
        ...state,
        [action.payload.permalink]: {
          ...state[action.payload.permalink],
          styled_products: action.payload.styledProducts,
        },
      }

    case 'SET_SELECTED_VARIANT':
      const variantArray = Object.values(state[action.payload.permalink].variants).map(variant => {
        const selected = variant.id === action.payload.variant.id

        return {
          ...variant,
          selected,
        }
      })

      return {
        ...state,
        selected_size: action.payload.variant.abbreviated_size,
        [action.payload.permalink]: {
          ...state[action.payload.permalink],
          variants: variantArray,
        },
      }

    case 'SET_SELECTED_PRODUCT':
      const productArray = Object.keys(state).map(key => {
        const selected = state[key].id === action.payload.product.id

        return {
          ...state[key],
          selected,
        }
      })
      const productObject = { ...keyBy(productArray, 'permalink') }

      return {
        ...state,
        ...productObject,
      }

    default:
      return state
  }
}

export function getAllProductsInProductGroup(state, productGroupId) {
  return Object.values(state)
    .filter(product => product.product_group_id === productGroupId)
    .filter(product => !product.retired)
}

export function getProductByPermalinkOrId(state, permalink) {
  return (
    state[permalink] || Object.values(state).find(product => product.id === parseInt(permalink))
  )
}

export function getProductById(state, id) {
  return Object.values(state).find(product => product.id === id)
}

export function getSelectedProduct(products) {
  return Object.values(products).find(product => product.selected === true)
}

export function getSelectedVariant(variants) {
  return Object.values(variants).find(variant => variant.selected === true)
}
